var Collection = require('Collection'),
    Container  = require("./Container"),
    $          = require("jquery"),
    Layer      = require("./Layer");

var ContainersCollection = Collection.extend({

    /**
     *
     */
    loadObjects: function(options){
        var that      = this,
            layers    = that.filter(function(cont){
                return (cont instanceof Layer)
            }),
            deferreds = [],
            objects = new Collection();

        if(options && 'raw' in options){
            delete options['raw']
        }

        layers.each(function(layer){
            deferreds.push(layer.loadObjects(options));
        });

        return $.when.apply(window, deferreds).then(function(){
            layers.each(function(layer){
                objects.add(layer.objects.getArray())
            });

            return objects;
        })
    },

    /**
     *
     */
    add: function(objects){
        var that = this,
            _objects,
            i;

        _objects = $.isArray(objects) ? objects : [objects];

        for (i in _objects) {
            if (_objects[i] && _objects[i] instanceof Container) {
                that._items.push(_objects[i]);
            }
        }
        return that;
    }
});

module.exports = ContainersCollection;



//////////////////
// WEBPACK FOOTER
// ./src/Project/ContainersCollection.js
// module id = 12
// module chunks = 0